import React from "react";

import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Button } from "react-bootstrap";

import useReserveClientSecret from "@/hooks/useReserve";
import { getCurrentLang } from "@/utils/Local";

import i18n from "../../i18n";
import LoaderComponent from "../Loader.component";
import ReserveCheckoutFormComponent from "./ReserveCheckoutForm.component";
import useReserveContext from "../../hooks/useReserveContext";

import type { StripeCheckoutElementsOptions } from "@stripe/stripe-js/dist/stripe-js/checkout";

const ErrorComponent: React.FC = () => {
  const { t } = i18n;
  const { setOpenSection, setShowConfirmModal, setHasError } =
    useReserveContext();

  setHasError(true);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center position-absolute h-100 w-100 gap-4">
      <FontAwesomeIcon icon={faBug} size="4x" />
      {t("_error_message")}

      <Button
        variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2"
        onClick={() => {
          setOpenSection(false);
          setShowConfirmModal(false);
        }}
      >
        <span>{t("Close")}</span>
      </Button>
    </div>
  );
};

const ReserveCheckoutComponent: React.FC = () => {
  const { isLoading, error, data } = useReserveClientSecret();
  const clientSecret = data?.client_secret;
  const stripePromise = loadStripe(
    import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? "",
    {
      locale: getCurrentLang(),
    },
  );
  const fetchClientSecret = async () => clientSecret ?? "";

  if (isLoading) {
    return <LoaderComponent />;
  }

  if (error || !clientSecret || clientSecret === "") {
    return <ErrorComponent />;
  }

  const appearance = {
    theme: "stripe",
  };
  const options = {
    fetchClientSecret,
    elementsOptions: { appearance } as StripeCheckoutElementsOptions,
  };

  return (
    <CheckoutProvider options={options} stripe={stripePromise}>
      <ReserveCheckoutFormComponent />
    </CheckoutProvider>
  );
};

export default ReserveCheckoutComponent;
